import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService,
  BokkzIbDataService,
  IncomeTaxEntity,
  Periode,
  PGAScholingsuitgaven,
  PrestatiebeursTerugBetaald,
  PrestatiebeursTerugBetaaldOnderwijsJaar
} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { number } from "mathjs";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-studiefinanciering-aangever',
  templateUrl: './studiefinanciering-aangever.component.html',
  styleUrls: ['./studiefinanciering-aangever.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class StudiefinancieringAangeverComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public terugBetaaldePrestatiebeursAangeverFg = {} as FormGroup

    public onderwijsJaar: SelectFormControlItem<PrestatiebeursTerugBetaaldOnderwijsJaar>[] = [
        {value: PrestatiebeursTerugBetaaldOnderwijsJaar.JAAR2014, label: "Studiejaar 2014/2015"},
        {value: PrestatiebeursTerugBetaaldOnderwijsJaar.JAAR2013, label: "Studiejaar 2013/2014"}
    ]

    public onderwijsJaar2025: SelectFormControlItem<PrestatiebeursTerugBetaaldOnderwijsJaar>[] = [
        {value: PrestatiebeursTerugBetaaldOnderwijsJaar.JAAR2014, label: "Studiejaar 2014/2015"},
    ]

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Ja"},
        {value: false, label: "Nee"}
    ]

    public studiemaandAanvang: SelectFormControlItem<string>[] = [];
    public studiemaandEind: SelectFormControlItem<string>[] = [];
    public studiemaandAanvang2025: SelectFormControlItem<string>[] = [];
    public studiemaandEind2025: SelectFormControlItem<string>[] = [];

    initializeStudiemaandAanvang(index: number) {
        const aangifte = this.incomeTaxEntity.aangifte;
        let jaar = aangifte?.aangifteJaar;
        const formGroup = this.terugBetaaldePrestatiebeursAangever.at(index) as FormGroup;
        const onderwijsJaarControl = formGroup.get('onderwijsJaar');

        if (onderwijsJaarControl?.getRawValue() === PrestatiebeursTerugBetaaldOnderwijsJaar.JAAR2014) {
            jaar = 2014;
        } else if (onderwijsJaarControl?.getRawValue() === PrestatiebeursTerugBetaaldOnderwijsJaar.JAAR2013) {
            jaar = 2013;
        }
        this.studiemaandAanvang = [
            {value: `${jaar}-08-01`, label: `Augustus ${jaar}`},
            {value: `${jaar}-09-01`, label: `September ${jaar}`},
            {value: `${jaar}-10-01`, label: `Oktober ${jaar}`},
            {value: `${jaar}-11-01`, label: `November ${jaar}`},
            {value: `${jaar}-12-01`, label: `December ${jaar}`},
            {value: `${jaar? jaar + 1 : ''}-01-01`, label: `Januari ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-02-01`, label: `Februari ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-03-01`, label: `Maart ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-04-01`, label: `April ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-05-01`, label: `Mei ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-06-01`, label: `Juni ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-07-01`, label: `Juli ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-08-01`, label: `Augustus ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-01-01`, label: `Januari ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-02-01`, label: `Februari ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-03-01`, label: `Maart ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-04-01`, label: `April ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-05-01`, label: `Mei ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-06-01`, label: `Juni ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-07-01`, label: `Juli ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-08-01`, label: `Augustus ${jaar? jaar + 2 : ''}`},
        ]
        this.studiemaandAanvang2025 = [
            {value: `${jaar}-08-01`, label: `Augustus ${jaar}`},
            {value: `${jaar}-09-01`, label: `September ${jaar}`},
            {value: `${jaar}-10-01`, label: `Oktober ${jaar}`},
            {value: `${jaar}-11-01`, label: `November ${jaar}`},
            {value: `${jaar}-12-01`, label: `December ${jaar}`},
            {value: `${jaar? jaar + 1 : ''}-01-01`, label: `Januari ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-02-01`, label: `Februari ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-03-01`, label: `Maart ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-04-01`, label: `April ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-05-01`, label: `Mei ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-06-01`, label: `Juni ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-07-01`, label: `Juli ${jaar? jaar + 1 : ''}`},
        ]

        this.studiemaandEind = [
            {value: `${jaar}-08-31`, label: `Augustus ${jaar}`},
            {value: `${jaar}-09-30`, label: `September ${jaar}`},
            {value: `${jaar}-10-31`, label: `Oktober ${jaar}`},
            {value: `${jaar}-11-30`, label: `November ${jaar}`},
            {value: `${jaar}-12-31`, label: `December ${jaar}`},
            {value: `${jaar? jaar + 1 : ''}-01-31`, label: `Januari ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-02-30`, label: `Februari ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-03-31`, label: `Maart ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-04-30`, label: `April ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-05-31`, label: `Mei ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-06-30`, label: `Juni ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-07-31`, label: `Juli ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-08-31`, label: `Augustus ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-01-31`, label: `Januari ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-02-30`, label: `Februari ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-03-31`, label: `Maart ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-04-30`, label: `April ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-05-31`, label: `Mei ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-06-30`, label: `Juni ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-07-31`, label: `Juli ${jaar? jaar + 2 : ''}`},
            {value: `${jaar? jaar + 2 : ''}-08-31`, label: `Augustus ${jaar? jaar + 2 : ''}`},
        ]
        this.studiemaandEind2025 = [
            {value: `${jaar}-08-31`, label: `Augustus ${jaar}`},
            {value: `${jaar}-09-30`, label: `September ${jaar}`},
            {value: `${jaar}-10-31`, label: `Oktober ${jaar}`},
            {value: `${jaar}-11-30`, label: `November ${jaar}`},
            {value: `${jaar}-12-31`, label: `December ${jaar}`},
            {value: `${jaar? jaar + 1 : ''}-01-31`, label: `Januari ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-02-30`, label: `Februari ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-03-31`, label: `Maart ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-04-30`, label: `April ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-05-31`, label: `Mei ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-06-30`, label: `Juni ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-07-31`, label: `Juli ${jaar? jaar + 1 : ''}`},
            {value: `${jaar? jaar + 1 : ''}-08-31`, label: `Augustus ${jaar? jaar + 1 : ''}`},
        ]
    }

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder, private router: Router) {
        this.terugBetaaldePrestatiebeursAangeverFg = this.fb.group({
            terugBetaaldePrestatiebeursAangever:
                this.fb.array<PGAScholingsuitgaven>([])
        })
    }

    get terugBetaaldePrestatiebeursAangever(): FormArray {
        return this.terugBetaaldePrestatiebeursAangeverFg.get('terugBetaaldePrestatiebeursAangever') as FormArray;
    }

    addRijTerugBetaaldePrestatiebeursAangever(): void {
        this.terugBetaaldePrestatiebeursAangever.push(this.createTerugBetaaldePrestatiebeursAangeverFormGroup()
        )
    }

    verwijderRijTerugBetaaldePrestatiebeursAangever(index: number): void {
        this.terugBetaaldePrestatiebeursAangever.removeAt(index);
        this.terugBetaaldePrestatiebeursAangeverFg.updateValueAndValidity()
        this.terugBetaaldePrestatiebeursAangeverFg.markAsDirty()
        this.saveForm()
    }

    createTerugBetaaldePrestatiebeursAangeverFormGroup(beurs?: PrestatiebeursTerugBetaald): FormGroup {
        return this.fb.group<PrestatiebeursTerugBetaald>({
            onderwijsJaar: beurs ? beurs.onderwijsJaar : undefined as unknown as PrestatiebeursTerugBetaaldOnderwijsJaar,
            terugbetaaldeBedrag: beurs ? beurs.terugbetaaldeBedrag : undefined as unknown as number,
            mbo: beurs ? beurs.mbo : undefined,
            hboWo: beurs ? beurs.hboWo : undefined,
            periodeWaaroverTerugbetaaldMoetWordenInMaanden: this.fb.group<Periode>({
                begindatum: beurs ? beurs.periodeWaaroverTerugbetaaldMoetWordenInMaanden.begindatum : undefined,
                einddatum: beurs ? beurs.periodeWaaroverTerugbetaaldMoetWordenInMaanden.einddatum : undefined
            }),
        } as PrestatiebeursTerugBetaald);
    }

    public ngOnInit(): void {
       this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
                this.terugBetaaldePrestatiebeursAangever.controls.forEach((control, index) => {
                    this.initializeStudiemaandAanvang(index);
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.terugBetaaldePrestatiebeursAangeverFg.dirty;
  }

  private updateForm(): void {
        const terugBetaaldePrestatiebeursAangeverLijst = this.aangifte?.persoonsgebondenAftrek?.pgaScholingsuitgaven?.terugBetaaldePrestatiebeursAangever || [];
        const formArray = this.terugBetaaldePrestatiebeursAangeverFg.get('terugBetaaldePrestatiebeursAangever') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > terugBetaaldePrestatiebeursAangeverLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < terugBetaaldePrestatiebeursAangeverLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(terugBetaaldePrestatiebeursAangeverLijst[i]);
            } else {
                const formGroup = this.createTerugBetaaldePrestatiebeursAangeverFormGroup(terugBetaaldePrestatiebeursAangeverLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            persoonsgebondenAftrek: {
                ...this.aangifte.persoonsgebondenAftrek,
                pgaScholingsuitgaven: {
                    ...this.aangifte.persoonsgebondenAftrek?.pgaScholingsuitgaven,
                    terugBetaaldePrestatiebeursAangever: this.terugBetaaldePrestatiebeursAangeverFg.value.terugBetaaldePrestatiebeursAangever
                }
            }
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }

    isHboDisabled(i: number): boolean {
        const mboControl = this.terugBetaaldePrestatiebeursAangever.controls[i].get('mbo');
        return mboControl?.value === true;
    }
    isMboDisabled(i: number): boolean {
        const hboControl = this.terugBetaaldePrestatiebeursAangever.controls[i].get('hboWo');
        return hboControl?.value === true;
    }

    isHboAndMboDisabled(i: number): boolean {
        const mboControl = this.terugBetaaldePrestatiebeursAangever.controls[i].get('mbo');
        const hboControl = this.terugBetaaldePrestatiebeursAangever.controls[i].get('hboWo');
        return mboControl?.value === false && hboControl?.value === false;
    }

}

